import React from 'react';
import DatePicker from 'react-datepicker';
import { getYear, getMonth } from 'date-fns';
import {
  Select,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { format, parseISO, isValid } from 'date-fns';

// Helpers (เหมือนเดิม)
const currentBuddhistYear = new Date().getFullYear() + 543;
const years = Array.from({ length: 91 }, (_, i) => currentBuddhistYear - 80 + i);
const months = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
];

// --- 1. แก้ไข CustomInput ---
// เราจะออกแบบให้มันรับ prop `displayValue` ที่เราสร้างเอง
// และเมินเฉย prop `value` ที่มาจาก react-datepicker
const CustomInput = React.forwardRef(({ onClick, displayValue, ...rest }, ref) => (
  <InputGroup>
    <Input
      {...rest}
      ref={ref}
      value={displayValue} // <--- ใช้ค่า พ.ศ. ที่เราส่งมาแสดงผล
      onClick={onClick}   // <--- ใชฟังก์ชันเปิดปฏิทินจาก react-datepicker
      readOnly
      placeholder="วว/ดด/ปปปป"
      cursor="pointer"
      autoComplete="off"
    />
    <InputRightElement onClick={onClick} cursor="pointer">
      <FaCalendarAlt color="gray.300" />
    </InputRightElement>
  </InputGroup>
));


// --- Component หลัก ---
const HybridThaiDatePicker = ({ value, onChange, name, ...rest }) => {
  const selectedDate = value && isValid(parseISO(value)) ? parseISO(value) : null;

  // สร้าง String สำหรับแสดงผลในช่อง Input ด้วยตัวเอง
  const displayValueForInput = selectedDate
    ? format(selectedDate, 'dd/MM/') + (getYear(selectedDate) + 543)
    : '';
  
  const handleDateChange = (date) => {
    const gregorianValue = date ? format(date, 'yyyy-MM-dd') : '';
    onChange({
      target: {
        name: name,
        value: gregorianValue,
      },
    });
  };

  return (
    <DatePicker
      selected={selectedDate}
      onChange={handleDateChange}
      // --- 2. ส่ง CustomInput ที่ออกแบบใหม่เข้าไป ---
      // เราส่งค่า `displayValueForInput` (ที่เป็น พ.ศ.) เข้าไปใน prop `displayValue` ของเรา
      customInput={<CustomInput displayValue={displayValueForInput} {...rest} />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <HStack justifyContent="space-between" p={2} bg="gray.50">
          <IconButton
            aria-label="Previous Month"
            icon={<FaChevronLeft />}
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            size="sm"
          />
          <HStack>
            <Select
              size="sm"
              width="90px" 
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
            >
              {months.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </Select>
            <Select
              size="sm"
              width="70px"
              value={getYear(date) + 543}
              onChange={({ target: { value } }) => changeYear(value - 543)}
            >
              {years.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </Select>
          </HStack>
          <IconButton
            aria-label="Next Month"
            icon={<FaChevronRight />}
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            size="sm"
          />
        </HStack>
      )}
      formatWeekDay={nameOfDay => nameOfDay.substring(0, 1)}
      // ไม่ต้องใช้ withPortal หรือ inline อีกต่อไป เพราะ customInput จะจัดการตำแหน่งเอง
    />
  );
};

export default HybridThaiDatePicker;